"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContactController_js_1 = require("./ContactController.js");
exports.ContactController = ContactController_js_1.ContactController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/contact/controllers/index.ts
// module id = 447
// module chunks = 0